import { NOTIFY_DELAY } from '../../../constants'

export default function notifyDelay (delayMs: number = NOTIFY_DELAY): Date {
    return new Date(new Date().getTime() + delayMs)
}
